import PriceSummary from './PriceSummary';

export default PriceSummary;
export type { PriceSummaryProps } from './GenericPriceSummary';
export type { PriceUpTo } from './PriceSummary.controller';
